export const createValues = (items) => items.map(([value, display]) => ({
  value,
  display: display || value,
  count: 0,
}));

export const createValuesBySteps = (items, opts = {}) => {
  const result = [];
  let i = opts.start || 0;
  let value = i;

  items.forEach(({ to, step }) => {
    let j;
    for (j = i; j < to; j += step) {
      value += step;
      result.push(value);
    }
    i = j;
  });

  const res = createValues([
    !opts.noEmpty && ['0', opts.empty || '-'],
    ...result.map((o) => [`${o}`]),
  ].filter(Boolean));
    //   console.log('Result', res);
  return res;
};
